import axios from 'axios';

import config from './../config';

const {baseUrl, key} = config.api;

const client = axios.create({
  baseURL: baseUrl,
});

//Agregamos Headers comunes a todos los request
client.interceptors.request.use(
  request => {
    if (!request.url.startsWith(baseUrl)) {
      let req = request;
      delete req.baseUrl;
     // console.log('## axios.req: ', req);
      return req;
    }

    //console.log('adding API common headers...');
    //Solo agregamos los headers si corresponde a nuestra API
    request.headers['Access-Control-Allow-Headers'] = 'x-access-token';
    request.headers['x-access-token'] = key;
  
    return request;
  },
  error => {
 
    return Promise.reject(error);
  },
);

//Mapeamos la respuesta de la API para que se ajuste a como manejamos nosotros
client.interceptors.response.use(
  response => {
    //console.log('## axios.res.success: ', JSON.stringify(response, null, 1));
    if (!response.config.url.startsWith(baseUrl)) {
      return response;
    }

    if (!response.data) {
      throw new Error('Error en response');
    }

    const newResponse = {
      data: response.data,
      // status: response.data.status,
      // message: response.data.mensaje,
    };
    return newResponse;
  },
  error => {

    return Promise.reject(error);
  },
);

export default client;
